import { render } from "./OTPModalControl.vue?vue&type=template&id=374ed1c0"
import script from "./OTPModalControl.vue?vue&type=script&lang=js"
export * from "./OTPModalControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\registration2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__